/* design-light · dl-attribution.js · UA Reklama attribution (2026-10-05, draft). Notes: NOTES-reklama-attribution.md */
(function(){
var IDS=['gclid','gbraid','wbraid','fbclid','msclkid','sznaiid','ttclid'],UTM=['source','medium','campaign','term','content'],
DAYS=90*864e5,MAX=1024,KEY='dl_attr',HK='dl_attr_h',PK='dl_attr_p',CK='dl_attr_c',
DROP='l.u.content f.u.content l.u.term f.u.term l.p f.p l.u.campaign f.u.campaign l.r f.r'.split(' ');
function dec(s){try{return decodeURIComponent(String(s).replace(/\+/g,' '));}catch(e){return String(s);}}
function query(qs){var o={};String(qs||'').replace(/^\?/,'').split('&').forEach(function(kv){if(!kv)return;var i=kv.indexOf('='),k=dec(i<0?kv:kv.slice(0,i)).toLowerCase();if(k&&!(k in o))o[k]=i<0?'':dec(kv.slice(i+1));});return o;}
function cut(s,n){return String(s==null?'':s).trim().slice(0,n);}
function host(u){var m=String(u||'').match(/^[a-z][a-z0-9+.-]*:\/\/([^\/?#:]+)/i);return m?m[1].toLowerCase():'';}
function own(h,s){h=h.replace(/^www\./,'');s=String(s||'').toLowerCase().replace(/^www\./,'');return !h||!s||h===s||h.slice(-s.length-1)==='.'+s||/(^|\.)(myshopify\.com|shopify\.com|shop\.app)$/.test(h);}
function touch(search,ref,path,site,now){
 var q=query(search),t={t:new Date(now||Date.now()).toISOString()},u={},i,v,has=false;
 for(i=0;i<5;i++){v=q['utm_'+UTM[i]];if(v){u[UTM[i]]=cut(v,60);has=true;}}
 if(has)t.u=u;
 for(i=0;i<7;i++)if(q[IDS[i]]){t.id={k:IDS[i],v:cut(q[IDS[i]],120)};has=true;break;}
 v=host(ref);if(v&&!own(v,site)){t.r=cut(v,80);has=true;}
 if(!has)return null;
 t.p=cut(String(path||'/').split('?')[0],120);return t;
}
function merge(prev,t,now){
 now=now||Date.now();
 var p=prev&&prev.f&&prev.exp>now?prev:null;
 if(!p&&!t)return null;
 return {v:1,f:p?p.f:t,l:t||p.l||p.f,c:p?p.c||null:null,exp:p?p.exp:now+DAYS};
}
function bytes(s){return encodeURIComponent(s).replace(/%[0-9A-F]{2}/g,'_').length;}
function pack(rec,c){
 if(!rec||!rec.f)return null;
 var o=JSON.parse(JSON.stringify({v:1,f:rec.f,l:rec.l||rec.f,c:c||rec.c||null})),s=JSON.stringify(o),i=0,d,x;
 while(bytes(s)>MAX&&i<DROP.length){d=DROP[i++].split('.');x=o[d[0]];if(d[2]){if(x.u)delete x.u[d[2]];}else delete x[d[1]];s=JSON.stringify(o);}
 return s;
}
if(typeof module!=='undefined'&&module.exports){module.exports={query:query,touch:touch,merge:merge,pack:pack,bytes:bytes};return;}
var W=window,D=document,L=W.location,ls=null,ss=null,CP=null,REC=null,timer=0,orig=null,
T=touch(L.search,D.referrer,L.pathname,L.hostname);
try{ls=W.localStorage;ss=W.sessionStorage;}catch(e){}
function noop(){}
function sget(st,k){try{return st?st.getItem(k):null;}catch(e){return null;}}
function sset(st,k,v){try{if(st){if(v==null)st.removeItem(k);else st.setItem(k,v);return true;}}catch(e){}return false;}
function cget(){var m=D.cookie.match(/(?:^|; )dl_attr=([^;]*)/);return m?dec(m[1]):null;}
function cset(v){try{D.cookie=KEY+'='+(v?encodeURIComponent(v):'')+';Max-Age='+(v?7776000:0)+';Path=/;SameSite=Lax;Secure';}catch(e){}}
function load(){var s=sget(ls,KEY);try{return JSON.parse(s==null?cget():s);}catch(e){return null;}}
function save(rec){var s=rec?JSON.stringify(rec):null;if(!sset(ls,KEY,s)||!s&&cget()!=null)cset(s);}
function state(){if(!CP)return null;try{if(CP.marketingAllowed())return 'yes';var v=CP.currentVisitorConsent&&CP.currentVisitorConsent();if(v&&v.marketing==='no')return 'no';return CP.shouldShowBanner&&CP.shouldShowBanner()?'pending':'no';}catch(e){return null;}}
function snap(){var m=false,a=false;try{m=!!CP.marketingAllowed();a=!!CP.analyticsProcessingAllowed();}catch(e){}return {m:m,a:a,t:new Date().toISOString()};}
function val(){return state()==='yes'&&REC?pack(REC):null;}
function hash(s){var h=0,i;for(i=0;i<s.length;i++)h=(h*31+s.charCodeAt(i))|0;return h+'';}
function hc(){var c=sget(ss,CK);return c?c==='1':/cart-has-items/.test(D.documentElement.className);}
function ap(){
 var st=state(),pend=null,prev,rec,c,pc;
 try{pend=JSON.parse(sget(ss,PK)||'null');}catch(e){}
 if(st==='yes'){
  prev=load();rec=merge(prev,T||pend,Date.now());
  if(rec){c=snap();pc=prev&&prev.c;rec.c=pc&&pc.m===c.m&&pc.a===c.a?pc:c;}
  save(rec);REC=rec;sset(ss,PK,null);if(rec)sch();
 }else if(st==='pending'){REC=null;if(T)sset(ss,PK,JSON.stringify(T));}
 else if(st==='no'){REC=null;save(null);sset(ss,PK,null);if(sget(ss,HK))sch();}
}
function wr(){
 timer=0;
 var v=val();
 if(v==null){if(state()!=='no'||!sget(ss,HK))return;v='';}
 if(!hc())return;
 var h=hash(v);if(sget(ss,HK)===h)return;
 (orig||W.fetch).call(W,'/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{_reklama:v}})})
  .then(function(r){if(r&&r.ok)sset(ss,HK,h);},noop);
}
function sch(){clearTimeout(timer);timer=setTimeout(function(){try{wr();}catch(e){}},600);}
function oc(){sset(ss,CK,'1');sch();}
function em(){sset(ss,CK,'0');sset(ss,HK,null);}
function op(e){var c=e&&e.cart;if(c&&c.item_count===0)em();else oc();}
try{
 orig=W.fetch;
 if(typeof orig==='function')W.fetch=function(input,init){
  var p=orig.apply(W,arguments);
  try{var u=String((input&&input.url)||input||''),b=init&&init.body,m=/\/cart\/(add|change|update|clear)\.js/.exec(u);
   if(m&&!(typeof b==='string'&&b.indexOf('"_reklama"')>=0))p.then(function(r){
    if(!r||!r.ok)return;
    if(m[1]==='clear')return em();
    if(m[1]==='add')return oc();
    try{r.clone().json().then(function(j){if(j&&j.item_count===0)em();else oc();},oc);}catch(e){oc();}
   },noop);
  }catch(e){}
  return p;
 };
}catch(e){}
try{var FT=W.FoxTheme,ev=FT&&FT.pubsub&&FT.pubsub.PUB_SUB_EVENTS&&FT.pubsub.PUB_SUB_EVENTS.cartUpdate;if(ev)FT.pubsub.subscribe(ev,op);}catch(e){}
D.addEventListener('cart:refresh',oc);
D.addEventListener('visitorConsentCollected',function(){try{CP=(W.Shopify&&W.Shopify.customerPrivacy)||CP;ap();}catch(e){}});
W.dlAttribution={get:function(){try{return JSON.parse(val());}catch(e){return null;}},attribute:val};
try{
 var S=W.Shopify;CP=S&&S.customerPrivacy;
 if(!CP&&S&&typeof S.loadFeatures==='function')S.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(err){try{if(!err){CP=S.customerPrivacy;ap();}}catch(e){}});
 else ap();
}catch(e){}
})();
